module.exports = __webpack_public_path__ + "img/page_paper_file_document_text_icon.e7eb0d41.svg";